<template>
    <div>
        <PdfViewerComp></PdfViewerComp>
        <!--<DrawingComp/>-->
        <div id="tab-sidebar-pate4">
            <div class="container">
                <div id="menu-tab-pate4" class="row">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <router-link :to="{ name: 'ebook-detail', params: { id: this.id, slug: this.slug } }"><i
                                class="fa fa-times"></i> Thoát
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                        <span>{{this.title!=null?this.title:(this.ebooksDetail!=null?this.ebooksDetail.name:'')}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row content-main-test">
                <div class="nav-left-list" v-show="isShowMenu">
                    <p>Mục lục</p>
                    <hr width="85%">
                    <div class="ebook-left">
                        <div>
                            <div class="chapter" v-for="chapter in ebooksDetail.chapters">
                                <a @click="readPage(chapter.page_no!=null?(chapter.page_no>186?186:chapter.page_no):0, (chapter.title!==null?chapter.title + ': ':'')+(chapter.name!==null?chapter.name:''),chapter.id)"
                                   class="chapter_title" data-toggle="collapse" href="#chapter1" aria-expanded="true">
                                    {{(chapter.title!==null?chapter.title + " : ":"")+chapter.name}}
                                    <!--{{chapter.name}}-->
                                </a>
                                <div class="collapse show" id="chapter1">
                                    <ul>
                                        <li v-for="lesson in chapter.lessons">
                                            <a :class="lessonId==lesson.id?'active':''" href="#"
                                               @click="readPage(lesson.page_no!=null?(lesson.page_no>186?186:lesson.page_no):0, (lesson.title!==null?lesson.title + ': ':'')+(lesson.name!==null?lesson.name:''),lesson.id)">
                                                <!--{{(lesson.title!==null?lesson.title + " : ":"")+lesson.name}}-->
                                                {{lesson.name}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- test -->
                <div class="content-test mt-4 content-ebook">
                    <div class="col-12">
                        <iframe id="ifr-view-book" src="http://localhost:3000/?url=toan-5.pdf" width="100%" height="600px"  scrolling="no"/>
                    </div>
                </div>

                <div class=" main-content-pate4">
                    <div>
                        <button id="search" type="button" @click="showSearch"
                                :class="isShowSearch?'icon-button btn-active':'icon-button'">
                            <i class="fa fa-search"></i>
                        </button>
                        <br>
                        <button id="note" type="button" @click="showNote"
                                :class="isShowNote?'icon-button btn-active':'icon-button'">
                            <i class="fa fa-file-alt"></i>
                        </button>
                        <br>
                        <button id="link" type="button" @click="showLinkShare"
                                :class="isShowLinkShare?'icon-button btn-active':'icon-button'">
                            <i class="fa fa-link"></i>
                        </button>
                        <br>
                        <button id="pen" type="button" @click="showColorPen"
                                :class="isShowColorPen?'icon-button btn-active':'icon-button'">
                            <i class="fa fa-pencil-alt"></i>
                        </button>
                        <div class="color-pen" v-show="isShowColorPen">
                            <button type="button" class="btn btn-secondary"></button>
                            <br>
                            <button type="button" class="btn btn-danger"></button>
                            <br>
                            <button type="button" class="btn btn-warning"></button>
                            <br>
                            <button type="button" class="btn btn-success"></button>
                            <br>
                            <button type="button" class="btn btn-info"></button>
                        </div>
                    </div>
                    <div class="nav-left-list search-tab" v-show="isShowSearch">
                        <p class="tracuu">Tra cứu</p>
                        <div class="search-of-right">
                            <input type="text" placeholder="Tìm kiếm" v-model="textSearch">
                            <i class="fa fa-search" @click="searchText"></i>
                        </div>
                        <hr width="85%">
                        <div class="m-3">
                            <b-tabs content-class="mt-3" justified>
                                <b-tab title="Trang" active>

                                    <div class="p-3 mb-3 bg-white rounded" v-for="post in searchResult">
                                            <a href="javascript:void(0)" @click="readPage(post.pageNo-1,'',0)">
                                                Trang {{post.pageNo - 1}}
                                            </a>
                                        </div>
                                </b-tab>
                                <b-tab title="Nội dung">
                                    <div class="p-3 mb-3 bg-white rounded" v-for="post in searchResult">
                                        <a href="javascript:void(0)" @click="readPage(post.pageNo-1,'',0)">
                                            <div v-for="highLight in post.highLights">
                                                <span v-html="highLight"></span>
                                            </div>
                                        </a>
                                    </div>
                                </b-tab>
                                <b-tab title="Bài"><p>I'm the tab with the very, very long title</p></b-tab>
                            </b-tabs>
                        </div>
                    </div>
                    <div class="nav-left-list table-note" v-show="isShowLinkShare">
                        <p class="tracuu">Link liên kết</p>
                        <hr width="85%">
                        <div class="search-of-right">
                            <input type="text" placeholder="Tìm kiếm">
                            <i class="fa fa-search"></i>
                        </div>
                        <div class="note-help">

                            <p v-show="getLesson(slide)>0">
                                <a href="javascript:void(0)" @click="luyenTap(getLesson(slide))" class="word active">Luyện
                                    tập trang {{slide}}</a>
                            </p>
                        </div>
                        <div class="note-help">
                            <p v-show="getLesson(slide+1)>0">
                                <a href="javascript:void(0)" @click="luyenTap(getLesson(slide+1))" class="word active">Luyện
                                    tập trang {{slide+1}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="footer-pate4">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 list-exam">
                        <button @click="showMenu" id="danhsach" class="btn btn-primary" type="button">

                            <span><i class="fa fa-bars"></i> Mục lục</span>
                        </button>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 next-footer-ebook">
                        <div id="next-page-ebook">
                            <!--<a href="javascript:void(0)" @click="luyenTap" v-show="id==115" class="word active">Luyện tập</a>-->
                            <button @click="first">
                                <i class="fa fa-backward"></i>
                            </button>
                            <button @click="prev">
                                <i class="fa fa-caret-left"></i>

                            </button>
                            <input id="page-number" type="text" :value="slide + ' - ' + (slide + 1)" disabled="disabled">
                            <button @click="next">
                                <i class="fa fa-caret-right"></i>
                            </button>
                            <button @click="last">
                                <i class="fa fa-forward"></i>
                            </button>
                        </div>
                        <div id="zoom-ebook">
                            <button @click="changeZoomLevel(-1)">-</button>
                            <input type="text" :value="zoom" v-on:keyup.enter="trySetNewZoom">
                            <button @click="changeZoomLevel(1)">+</button>
                        </div>
                        <button id="zoom-ebook-full"><i class="fa fa-expand"></i></button>

                    </div>
                </div>
            </div>
        </div>
        <b-modal
                id="modal-exercise"
                v-model="isShowExercise"
                centered
                size="xl"
        >
            <div>
                <!-- <ExerciseSubjectDetail :questionId="lessonId"></ExerciseSubjectDetail> -->
            </div>
        </b-modal>
    </div>
</template>

<script>

    class Post {
        constructor(title, link, author, img) {
            this.title = title;
            this.link = link;
            this.author = author;
            this.img = img;
        }
    }

    import {mapGetters} from 'vuex';
    import {STORE_KEY} from '../_store/constants'
    //import moment from 'moment'
    //import store from '../_store'
    //import DrawingComp from './DrawingComp'
    //import ExerciseSubjectDetail from './ExerciseSubjectDetail'
    import PdfViewerComp from '../../../libs/PdfViewerComp.vue'
    export default {
        name: 'EBookDetailRead2',
        components: {
            //DrawingComp,
            //ExerciseSubjectDetail,
            PdfViewerComp
        },
        data() {
            return {
                id: this.$route.params.id,
                slug: this.$route.params.slug,
                slide: 0,
                pageSlides: [
                    {id: "1", pathUrl: "toan_lop-5_001.jpg", name: "Tiêu đề 001"}
                ],
                sliding: null,
                isShowMenu: false,
                isShowSearch: false,
                isShowNote: false,
                isShowLinkShare: false,
                isShowColorPen: false,
                title: null,
                isShowExercise: false,
                zoom: 50,
                lessonId: 0,
                textSearch: "",
                postList: []
            }
        },
        computed: {
                ...mapGetters({
                    ebooksDetail: STORE_KEY + '/ebooksDetail',
                    searchResult: STORE_KEY + '/searchResult'
                }),
        filteredList: function () {
            return this.postList.filter(post => {
                        return post.title.toLowerCase().includes(this.textSearch.toLowerCase())
                    }
            )
        }
    }
    ,
    mounted()
    {
        this.$store.dispatch(STORE_KEY + '/getEBooksDetail', this.id);
    }
    ,

    methods: {
        //
        // Zooming page functions
        //
        changeZoomLevel(nz)
        {

            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func: nz>0?"zoom-in":"zoom-out",value:"test"}, 'http://localhost:3000');
        }
    ,
        pageUrl(index)
        {
            //return require(`@/assets/books/${this.ebooksDetail.slug}_${this.padZeroes(index, 3)}.jpg`);
            return "";
        }
    ,
        showMenu()
        {
            this.isShowMenu = !this.isShowMenu;
            if (this.isShowMenu) {
                this.isShowSearch = false;
                this.isShowNote = false;
                this.isShowColorPen = false;
                this.isShowLinkShare = false;
            }
        }
    ,
        showSearch()
        {
            this.isShowSearch = !this.isShowSearch;
            if (this.isShowSearch) {
                this.isShowMenu = false;
                this.isShowNote = false;
                this.isShowColorPen = false;
                this.isShowLinkShare = false;
            }
        }
    ,
        showNote()
        {
            this.isShowNote = !this.isShowNote;
            if (this.isShowNote) {
                this.isShowMenu = false;
                this.isShowSearch = false;
                this.isShowColorPen = false;
                this.isShowLinkShare = false;
            }
        }
    ,
        showLinkShare()
        {
            this.isShowLinkShare = !this.isShowLinkShare;
            if (this.isShowLinkShare) {
                this.isShowMenu = false;
                this.isShowSearch = false;
                this.isShowColorPen = false;
                this.isShowNote = false;
            }
        }
    ,
        showColorPen()
        {
            this.isShowColorPen = !this.isShowColorPen;
            if (this.isShowColorPen) {
                this.isShowMenu = false;
                this.isShowSearch = false;
                this.isShowNote = false;
                this.isShowLinkShare = false;
            }
        }
    ,
        prev()
        {
            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func:"previous",value:"test"}, 'http://localhost:3000');
        }
    ,
        next()
        {

            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func:"next",page:this.slide}, 'http://localhost:3000');
        }
    ,
        first()
        {
            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func:"first",value:"test"}, 'http://localhost:3000');
        }
    ,
        last()
        {
            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func:"last",value:"test"}, 'http://localhost:3000');
        }
    ,
        readPage(index, title, lessonId)
        {
            console.log(title)
            this.title = title;
            this.lessonId = lessonId;

            var frame = document.getElementById('ifr-view-book');
            frame.contentWindow.postMessage({func:"readpage", page: index}, 'http://localhost:3000');

////      if(parseInt(index)>=3){
////        index=parseInt(index)-1;
////      }
//            this.$refs.myCarousel.setSlide(index)
        }
    ,
        padZeroes(number, length)
        {

            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = '0' + my_string;
            }
            return my_string;
        }
    ,
        luyenTap(lId)
        {
            this.lessonId = lId;
            this.isShowExercise = !this.isShowExercise;
        }
    ,
        setActiveLesson(page)
        {
            var tmpLesson = 0;
            for (var i = 0; i < this.ebooksDetail.chapters.length; i++) {
                if (tmpLesson == 0) {
                    for (var j = 0; j < this.ebooksDetail.chapters[i].lessons.length; j++) {
                        if (this.ebooksDetail.chapters[i].lessons[j].page_no > page) {
                            tmpLesson = this.ebooksDetail.chapters[i].lessons[j].id;
                            break;
                        }
                    }
                }
                else {
                    break;
                }
            }
            this.lessonId = tmpLesson;
        }
    ,
        getLesson(page)
        {
            var tmpLesson = 0;
            if (this.ebooksDetail.book_type_id == 1 || page < 3)
                return 0;
            for (var i = 0; i < this.ebooksDetail.chapters.length; i++) {
                if (tmpLesson == 0) {
                    for (var j = 0; j < this.ebooksDetail.chapters[i].lessons.length; j++) {
                        if (this.ebooksDetail.chapters[i].lessons[j].page_no >= page) {
                            tmpLesson = this.ebooksDetail.chapters[i].lessons[j].id;
                            break;
                        }
                    }
                }
                else {
                    break;
                }
            }
            return tmpLesson;
        }
    ,
        searchText()
        {
            console.log("searchText")
            this.$store.dispatch(STORE_KEY + '/getBookSearch', this.textSearch);
        }

    }
    }


            function changePage(activePage) {
                document.getElementById("page-number").value = activePage;
            }
    window.addEventListener('message', function(event) {
        if (event.origin.startsWith('http://localhost:3000')) {
            if(event.data.func=='change-page'){
                changePage(event.data.activePage);
            }
        }
    });
</script>
<style>


    /*main-content*/

    .class-name {
        color: black !important;
        font-size: 20px;
    }

    .class-number {
        padding: 10px 20px 0 20px;
        border-radius: 10px;
        margin-top: 24px;
    }

    .class-number:hover {
        background: #F3F6FB;
    }

    /*footer*/

    .footer p {
        color: #879AA9;
        margin-top: 45px;
    }

    .footer li {
        color: #879AA9;
        padding-top: 5px;
    }

    .footer ul {
        padding: 0;
    }

    .footer a,
    .footer p {
        font-size: 16px;
    }

    #footer-pate1 {
        padding-top: 80px;
        background: #F3F6FB;
    }

    #footer-pate1 p {
        color: #879AA9;
        padding-bottom: 35px;
    }

    .cool {
        padding-bottom: 128px !important;
    }

    #footer-buttom {
        font-size: 12px;
    }

    /*The end pate1*/

    /*pate3*/

    .on-number {
        width: 20px;
        height: 20px;
        border: none;
        border-radius: 10px;
        background: #124ABE;
        color: white;
        text-align: center;
        margin: 3px 10px 3px 3px;
    }

    /*pate4*/

    #tab-sidebar-pate4 {
        background: #F3F6FB;
        border-top: 1px solid #CDD1D3;
        border-bottom: 1px solid #CDD1D3;
    }

    #menu-tab-pate4 {
        justify-content: space-between;
        padding: 10px 0;
        font-size: 14px;
        color: #879AA9;
    }

    .main-content-pate4 {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .main-content-pate4 i {
        color: #124ABE;
    }

    .dths {
        text-align: center;
    }

    .search-pen {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        color: #124ABE;
    }

    /*footer-pate4*/

    #footer-pate4 {
        background: #F3F6FB;
        color: #124ABE;
        border-top: 1px solid #CDD1D3;
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
    }

    .list-exam button {
        background: #F3F6FB;
        border: none;
        color: #124ABE;
        border-radius: 30px;
        width: 105px;
        height: 30px;
        margin: 10px 20px;
    }

    #test button {
        background: #124ABE;
        color: white;
        border: none;
        border-radius: 30px;
        width: 240px;
        height: 30px;
        margin: 10px 20px;
    }

    #next-pate {
        display: flex;
        align-items: center;
        height: 30px;
        border-right: 1px solid #879AA9;
        margin-top: 10px;
    }

    #next-pate i {
        font-size: 30px;
        padding: 0 20px;
    }

    /*test*/

    .nav-left-list {
        display: block;
        background: #F3F6FB;
        height: 640px;
        width: 300px;
        overflow: scroll;
        transition: margin-left .4s ease-in;
        -webkit-transition: margin-left .4s ease-in;
    }

    .nav-left-list p {
        font-size: 16px;
        color: #40505E;
        padding: 30px 0 0 30px;
    }

    .nav-left-list td {
        font-size: 18px;
        padding: 15px 35px;
        border-radius: 15px;
    }

    .list-exam-pate5 ul {
        display: flex;
        margin: 0;
    }

    .list-exam-pate5 li {
        padding: 0px 20px;
        margin: 0 6px;
        border-radius: 10px;
        color: #879AA9;
        cursor: pointer;
        border: 1px solid #F3F6FB;
    }

    .list-exam-pate5 li:hover {
        opacity: 0.7;
        border: 1px solid #879AA9;
    }

    #n1 {
        border: 1px solid #124ABE;
    }

    #n1 button {
        border: 1px solid #124ABE;
    }

    #n2 {
        background: #74DCC1;
    }

    #n3 {
        background: #FD6C6F;
    }

    .content-main-test {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .nav-left-list::-webkit-scrollbar {
        width: 8px;
        height: 0;
        background-color: #F3F6FB;
    }

    .nav-left-list::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #F3F6FB;
    }

    .nav-left-list::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #879AA9;
        border: 1px solid #F3F6FB;
    }

    .search-tab, .table-note, .table-link {
        background: #F3F6FB;
        height: 640px;
        overflow: scroll;
    }

    .tracuu {
        font-size: 20px;
        color: #40505E;
        padding: 20px 0 0 20px;
    }

    .search-tab input, .table-note input, .table-link input {
        border: unset;
        margin-left: 20px;
        width: 220px;
        height: 30px;
        border-radius: 20px;
        border: none;
        margin: 0 10px;
        font-size: 14px;
    }

    .search-of-right {
        background: white;
        border-radius: 20px;
        width: 270px;
        height: 30px;
        margin: 0px 15px;
    }

    .note-help {
        margin: 0px 0 30px;
        background: #F3F6FB;
        /* border-radius: 10px; */
        width: 280px;
    }

    .note-help p {
        padding: 15px 20px;
        margin: 0;
    }

    .icon-button {
        background: white;
        border: none !important;
        padding: 10px 10px;
        min-width: 50px;
    }

    #search {
        margin-top: 30px;
        outline: 0 !important;
    }

    .color-pen button {
        width: 30px;
        height: 30px;
        border-radius: 0;
        margin: 5px 13px;
        border: none;
    }

    .color-pen {
        background: #F3F6FB;
    }

    /*content-main*/

    .content-test {
        width: 300px;
        height: 592px;
        flex-grow: 1;
        text-align: center;
    }

    a {
        color: #879AA9;
        text-decoration: none !important;
    }

   /*  a:hover {
        color: #124ABE !important;
    }
 */
    #test-pate:focus {
        outline: 0;
    }

    .search-of-right input:focus {
        outline: 0;
    }

    /* HS_E-BOOK-page1 */

    .list-ebook-left-1,
    .list-ebook-left-2,
    .list-ebook-left-3,
    .list-ebook-left-4 {
        display: none;
    }

    .ebook-left span {
        padding: 10px 20px;
        cursor: pointer;
    }

    .ebook-left span:hover {
        color: #124ABE;
    }

    .ebook-left li {
        padding: 5px 20px;
    }

   /*  .chevron-next {
        padding: 180px 20px;
    } */

    .content-ebook {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 40px !important;
    }

    .next-footer-ebook {
        display: flex;
        align-items: center;
    }

    #next-page-ebook button {
        background: #124ABE;
        border-radius: 20px;
        border: none;
        width: 60px;
        height: 30px;
        margin: 0 5px;
        outline: 0;
    }

    #next-page-ebook input {
        height: 30px;
        width: 100px;
        border-radius: 20px;
        border: none;
        margin: 0 5px;
        text-align: center;
    }

    #next-page-ebook i {
        color: white;
    }

    #zoom-ebook {
        background: white;
        border-radius: 20px;
        margin: 0 30px;
    }

    /* #zoom-ebook button {
        background: white;
        height: 30px;
        width: 30px;
        border-radius: 20px;
        border: none;
        font-size: 20px;
    } */

    #zoom-ebook input {
        width: 50px;
        border: none;
        height: 30px;
        text-align: center;
    }

    #zoom-ebook-full {
        background: #F3F6FB;
        border: none;
    }

    .fa-chevron-left,
    .fa-chevron-right {
        font-size: 30px;
    }

    .btn-active {
        background: #F3F6FB;
    }

    .chapter ul {
        list-style-type: none;
        margin-left: 10px;
    }

    .chapter a {
        color: #212529;
        font-size: 13px;
        display: inline-block;
    }

    /* .chapter a.active {
        color: #124ABE !important;
    } */

    .chapter a.chapter_title {
        color: #212529;
        padding: 5px 30px;
        font-size: 13px;
        display: inline-block;
    }

    .ebook-left {
        max-width: 300px;
    }

    #carouselExampleIndicators {
        overflow: auto !important;
    }

    .carousel-inner {
        overflow: auto !important;
    }

    .book-slide {
        margin-left: auto;
        margin-right: auto;
        max-width: 1000% !important;
    }
    iframe{
        overflow: hidden !important;
        border: none;
        -ms-overflow-style: none;
    scrollbar-width: none;
    }
    iframe::-webkit-scrollbar {
        display: none;
    }
</style>
